import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/hotelRoomDictionaryInfo', request)
}

export {get}
